import {
  getPlanData,
  getSalesTemplate,
  getContractDetails,
  simpleActivationPost,
  itemDetailsByQuery,
  getItemDetails,
  getPairedItemDetails,
  fetchQuoteAndLeadId,
} from "@/http/customer/customer";
import {
  paymentsMethodsApi,
  makePaymentApi,
  paymentsDetailsApi,
  paymentCompletedApi,
  afterPaymentApi,
} from "@/http/customer/customerActivation";

export default {
  namespaced: true,
  state: {
    planData: [],
    saleTemplateList: [],
    contractData: {},
    itemList: [],
    itemDetail: {},
    pairedItemList: [],
    deviceDetails: {},
    pairedItemDetails: {},
  },
  actions: {
    async setPlanData({ commit }, data) {
      const response = await getPlanData(data.country, data.state);
      commit("SET_PLAN_DATA", response.data.plandata);
      return response;
    },
    async getSalesTemplateList({ commit }, id) {
      const resp = await getSalesTemplate(id);
      commit("SET_SALES_TEMPLATE", resp.data.plandata);
      return resp;
    },
    async setContractDetails({ commit }, id) {
      const response = await getContractDetails(id);
      commit("SET_CONTRACT_DETAILS", response.data);
      return response;
    },
    async simpleActivationAction(_, payload) {
      const response = await simpleActivationPost(payload);
      return response;
    },
    async setItemDetailsByQuery({ commit }, query) {
      const response = await itemDetailsByQuery(query.loc, query.sl);
      commit("ITEM_DETAILS_BY_QUERY", response.data);
      return response;
    },
    async setItemDetails({ commit }, query) {
      const response = await getItemDetails(query.loc, query.sl);
      commit("SET_ITEM_DETAILS", response.data);
      if (query.type) {
        commit("SET_ITEM_DETILS_BY_TYPE", {
          data: response.data,
          type: query.type,
        });
      }
      return response;
    },
    async setPairedItemDetails({ commit }, data) {
      const resp = await getPairedItemDetails(data.slno, data.sl);
      commit("SET_PAIRED_ITEM_LIST", resp.data);
      return resp;
    },
    async getLeadIdbyQuoteNumber(_, id) {
      return await fetchQuoteAndLeadId(id);
    },
    async makePayments(_, payload) {
      return await makePaymentApi(payload);
    },
    async afterPayments(_, payload) {
      return await afterPaymentApi(payload);
    },
    async fetchPaymentMethods(_, payload) {
      return await paymentsMethodsApi(payload);
    },
    async fetchPaymentDetails(_, payload) {
      return await paymentsDetailsApi(payload);
    },
    async sendPaymentResponse(_, payload) {
      return await paymentCompletedApi(payload);
    },
  },
  mutations: {
    SET_PLAN_DATA(state, payload) {
      state.planData = payload;
    },
    SET_SALES_TEMPLATE(state, payload) {
      state.saleTemplateList = payload;
    },
    SET_CONTRACT_DETAILS(state, payload) {
      state.contractData = payload;
    },
    ITEM_DETAILS_BY_QUERY(state, payload) {
      state.itemList = payload;
    },
    SET_ITEM_DETAILS(state, payload) {
      state.itemDetail = payload;
    },
    SET_ITEM_DETILS_BY_TYPE(state, payload) {
      state[payload.type] = payload.data;
    },
    SET_PAIRED_ITEM_LIST(state, payload) {
      state.pairedItemList = payload;
    },
  },
  getters: {
    getClientEditBillId(state) {
      return state.clientsDataEditId;
    },
    getClientBillId(state) {
      return state.clientsDataId;
    },
  },
};
